module.exports = __webpack_public_path__ + "static/media/files.c80ed50a.svg";